export const getDateFormat = (
  date?: string | null,
  format: 'short' | 'full' | 'yearOnly' = 'short',
  locale?: string,
) => {
  if (!date) return ''

  try {
    const dateObj = new Date(date)

    if (isNaN(dateObj.getTime())) return ''

    const localeParam = locale || 'en'
    const localeFormat = localeParam === 'en' ? 'en-US' : 'de-DE'

    // const options: Intl.DateTimeFormatOptions =
    //   format === 'short'
    //     ? { month: 'short', year: 'numeric' }
    //     : { day: '2-digit', month: '2-digit', year: 'numeric' }

    const options: Record<string, Intl.DateTimeFormatOptions> = {
      short: { month: '2-digit', year: 'numeric' },
      full: { day: '2-digit', month: '2-digit', year: 'numeric' },
      yearOnly: { year: 'numeric' },
    }

    return dateObj.toLocaleDateString(localeFormat, options[format] as Intl.DateTimeFormatOptions)
  } catch {
    return ''
  }
}
